import React, { useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { d as _typeof, _ as _taggedTemplateLiteral, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './reduce-359d9da9.js';
import './_isIterateeCall-c4941c92.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import { _ as _noop } from './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';
import './isNull-db706d68.js';
import './chain-d06384bf.js';
import './Button.js';
import { g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';
import './range-409eafd0.js';
import { eachDayOfInterval, isDate, startOfWeek, startOfMonth, endOfWeek, endOfMonth, getDate, isToday, isSunday, isSameDay, isSameMonth, setYear, getYear, setMonth, getMonth, setDate } from 'date-fns';
import { _ as _forEach } from './forEach-18e9e52f.js';
import { c as chainedRender } from './chainedRender-bf38fc02.js';
import InputMonth from './InputMonth.js';
import './isString-30e5fe84.js';
import './Select.js';

var getDaysToDisplay = function getDaysToDisplay(date) {
  var weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!isDate(date)) {
    throw new Error('Expecting a date object, got', _typeof(date));
  } // Rewind time back to the first weekday after the end of the month


  var firstDayToDisplay = startOfWeek(startOfMonth(date), {
    weekStartsOn: weekStartsOn
  }); // Advance time to the last weekday after the end of the month

  var lastDayToDisplay = endOfWeek(endOfMonth(date), {
    weekStartsOn: weekStartsOn
  });
  return eachDayOfInterval({
    start: firstDayToDisplay,
    end: lastDayToDisplay
  });
};

var arrangeDaysIntoWeeks = function arrangeDaysIntoWeeks(days) {
  var weeks = {};

  _forEach(days, function (day, index) {
    var weekIndex = Math.floor(index / 7);

    if (!weeks[weekIndex]) {
      weeks[weekIndex] = [];
    }

    weeks[weekIndex].push(day);
  });

  return weeks;
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  margin: ", ";\n  padding: ", ";\n\n  min-width: ", ";\n\n  padding: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCalendarContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return getSpacesAsCss(theme.components.inputCalendar.spaces, 'margin');
}, function (_ref2) {
  var theme = _ref2.theme;
  return getSpacesAsCss(theme.components.inputCalendar.spaces, 'padding');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.inputCalendar.maxWidth;
});

var renderContainer = function renderContainer(_ref) {
  var className = _ref.className,
      cursorValue = _ref.cursorValue,
      yearRange = _ref.yearRange,
      handleCursorChange = _ref.handleCursorChange,
      locale = _ref.locale,
      children = _ref.children;
  return React.createElement(StyledCalendarContainer, {
    className: className
  }, React.createElement(InputMonth, {
    value: cursorValue,
    onChange: handleCursorChange,
    withNextPrevButtons: true,
    yearRange: yearRange,
    locale: locale
  }), children);
};

renderContainer.defaultProps = {
  className: '',
  cursorValue: '',
  handleCursorChange: _noop,
  yearRange: null,
  locale: null
};
renderContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  cursorValue: PropTypes.string,
  handleCursorChange: PropTypes.func,
  yearRange: PropTypes.arrayOf(PropTypes.number),
  locale: PropTypes.any
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-grow: 1;\n  text-align: center;\n  margin: ", ";\n\n  span {\n    display: inline-flex;\n    width: 25px;\n    height: 25px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n\n    ", "\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var getColor = function getColor(isSameMonth, isSunday, isToday, isSelected, theme) {
  return "\n  ".concat(!isSameMonth ? "color: ".concat(theme.notSameMonth, ";") : '', "\n  ").concat(isSunday ? "color: ".concat(theme.sunday, ";") : '', "\n  ").concat(isToday ? "color: ".concat(theme.today, ";") : '', "\n  ").concat(isSelected ? "\n    color: ".concat(theme.selected, ";\n    background-color: ").concat(theme.backgroundSelected, ";\n    ") : '', "\n");
};

var StyledDay = styled(Text)(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.inputCalendar.day.width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.inputCalendar.day.height;
}, function (_ref3) {
  var theme = _ref3.theme;
  return getSpacesAsCss(theme.components.inputCalendar.day.spaces, 'margin');
}, function (_ref4) {
  var isSameMonth = _ref4.isSameMonth,
      isSelected = _ref4.isSelected,
      isSunday = _ref4.isSunday,
      isToday = _ref4.isToday,
      theme = _ref4.theme;
  return getColor(isSameMonth, isSunday, isToday, isSelected, theme.components.inputCalendar.colors);
});

var renderDay = function renderDay(_ref) {
  var value = _ref.value,
      cursorValue = _ref.cursorValue,
      day = _ref.day,
      handleOnChange = _ref.handleOnChange;
  return React.createElement(StyledDay, {
    key: getDate(day),
    isToday: isToday(day),
    isSunday: isSunday(day),
    onClick: function onClick() {
      return handleOnChange(day);
    },
    isSelected: isSameDay(value, day),
    isSameMonth: isSameMonth(cursorValue, day)
  }, React.createElement("span", null, getDate(day)));
};

renderDay.defaultProps = {
  day: null,
  value: null,
  cursorValue: null,
  handleOnChange: _noop
};
renderDay.propTypes = {
  day: PropTypes.object,
  value: PropTypes.object,
  cursorValue: PropTypes.object,
  handleOnChange: PropTypes.func
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n\n  margin: ", ";\n  padding: ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWeek = styled.div(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return getSpacesAsCss(theme.components.inputCalendar.week.spaces, 'margin');
}, function (_ref2) {
  var theme = _ref2.theme;
  return getSpacesAsCss(theme.components.inputCalendar.week.spaces, 'padding');
});

var renderWeek = function renderWeek(_ref) {
  var children = _ref.children,
      week = _ref.week;
  return React.createElement(StyledWeek, {
    key: week[0]
  }, children);
};

renderWeek.propTypes = {
  children: PropTypes.node.isRequired,
  week: PropTypes.array.isRequired
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var InputCalendar = function InputCalendar(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      cursorValue = _ref.cursorValue,
      yearRange = _ref.yearRange,
      locale = _ref.locale,
      renderContainer$1 = _ref.renderContainer,
      renderDay$1 = _ref.renderDay,
      renderWeek$1 = _ref.renderWeek;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var _useState3 = useState(cursorValue || value || defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      stateCursor = _useState4[0],
      setStateCursor = _useState4[1]; // Store current value in state


  useEffect(function () {
    if (isDate(value)) {
      setStateValue(value);
    }
  }, [value]); // Store current cursor in state

  useEffect(function () {
    if (isDate(cursorValue)) {
      setStateCursor(cursorValue);
    }
  }, [cursorValue]);

  var handleOnChange = function handleOnChange(day) {
    var newDate = setYear(stateValue, getYear(day));
    newDate = setMonth(newDate, getMonth(day));
    newDate = setDate(newDate, getDate(day));
    setStateValue(newDate);
    setStateCursor(newDate);
    onChange(newDate);
  };

  var handleCursorChange = function handleCursorChange(value) {
    setStateCursor(value);
  };

  var days = getDaysToDisplay(stateCursor);
  var daysPerWeek = arrangeDaysIntoWeeks(days);
  return chainedRender(renderContainer, renderContainer$1, {
    className: className,
    cursorValue: stateCursor,
    handleCursorChange: handleCursorChange,
    value: stateValue,
    handleOnChange: handleOnChange,
    yearRange: yearRange,
    locale: locale,
    children: React.createElement(React.Fragment, null, _map(daysPerWeek, function (week) {
      return chainedRender(renderWeek, renderWeek$1, {
        className: className,
        cursorValue: stateCursor,
        handleCursorChange: handleCursorChange,
        value: stateValue,
        handleOnChange: handleOnChange,
        week: week,
        children: React.createElement(React.Fragment, null, _map(week, function (day) {
          return chainedRender(renderDay, renderDay$1, {
            className: className,
            cursorValue: stateCursor,
            handleCursorChange: handleCursorChange,
            value: stateValue,
            handleOnChange: handleOnChange,
            week: week,
            day: day
          });
        }))
      });
    }))
  });
};

InputCalendar.defaultProps = {
  className: '',
  defaultValue: new Date(),
  value: null,
  cursorValue: null,
  onChange: _noop,
  renderContainer: null,
  renderDay: null,
  renderWeek: null,
  locale: null
};
InputCalendar.propTypes = {
  /**
   * The classes of the select.
   */
  className: PropTypes.string,

  /**
   * The defaultValue of the select.
   */
  defaultValue: PropTypes.instanceOf(Date),

  /**
   * The value of the select.
   */
  value: PropTypes.instanceOf(Date),

  /**
   * The value selected of the select.
   */
  cursorValue: PropTypes.instanceOf(Date),

  /**
   * The function called when the value changes.
   */
  onChange: PropTypes.func,
  yearRange: PropTypes.arrayOf(PropTypes.number),
  renderContainer: PropTypes.func,

  /**
   * The function to override the rendering of the Day.
   */
  renderDay: PropTypes.func,

  /**
   * The function to override the rendering of the Week.
   */
  renderWeek: PropTypes.func,
  locale: PropTypes.any
};
InputCalendar.StyledCalendarContainer = StyledCalendarContainer;
InputCalendar.StyledDay = StyledDay;
InputCalendar.StyledWeek = StyledWeek;
/** @component */

var index = styled(React.memo(InputCalendar))(_templateObject$3());

export default index;
